export const cleanCnpj = (value?: string | null): string =>
  (value || "").replace(/[^a-zA-Z0-9]/g, "").toUpperCase();
